import Logo from '../assets/images/img-logo-0.svg';
import IconUser from '../assets/images/icon-user-0.svg';
import Setting from '../assets/images/Setting.svg';
import '../styles/css/jga_style.scss';
import '../styles/css/font.scss';
import { SetterOrUpdater } from 'recoil';
import { TMainPage, TUserInformation, TUserState } from '@metadata';
import { useNavigate } from 'react-router-dom';

type TProps = {
  userInfo: TUserInformation;
  userState: TUserState; // 사용자 상태 전달 받아 버튼 노출 제어
  setMain: SetterOrUpdater<TMainPage>;
  setUserState: SetterOrUpdater<TUserState>;
  logoutApi: any;
  homeUrl: string;
  SSOURL: string;
  onUserNameClick?: () => void;
  backgroundColor?: string;
};

const MainHeaderTemplate = (props: TProps) => {
  const { userInfo, userState, setMain, setUserState, logoutApi, homeUrl, SSOURL, onUserNameClick, backgroundColor } =
    props;
  const navigate = useNavigate();

  const logoutEvent = () => {
    const loginType = userInfo?.login_type;

    //  로그인 정보 제거
    setUserState((prevState) => ({
      ...prevState,
      UserInformation: {
        regUserId: '',
        regUserName: '',
        userId: '',
        ofcNm: '',
        CompanyID: '',
        CompanyName: '',
        ServiceID: '',
        token: '',
        ctpvNm: '',
        deptNm: '',
      },
      isLogin: false,
      isAdmin: false,
      stae: {
        ADMIN: '',
        CROPS: '',
        FORST: '',
        OCEAN: '',
        VEHICLE: '',
      },
      userService: {
        ADMIN: '',
        CROPS: '',
        FORST: '',
        OCEAN: '',
        VEHICLE: '',
      },
      currentPage: {
        title: '',
        url: '/',
      },
    }));

    //로그아웃 세션 삭제
    logoutApi();
    alert('정상적으로 로그아웃 되었습니다.');

    // 로그인 타입에 따라 로그인 페이지로 이동
    if (loginType === 'sso') {
      window.location.href = SSOURL;
    } else {
      window.location.href = '/login';
    }
  };

  // 관리자 승인 여부(각 서비스별 MANAGER && 승인) 또는 SUPER 권한
  const isManagerApproved = userState?.userService?.ADMIN === 'SUPER' && userState?.stae?.ADMIN === '승인';

  return (
    <header
      className="header"
      style={{ backgroundColor: backgroundColor, height: '72px', borderColor: '#f3f2ec' }}
    >
      <div className="hLogo">
        <a href={homeUrl}>
          <img src={Logo} />
        </a>

        <span>
          <a href="/">공간지능정보(Geo-AI) 융합 영상분석 행정서비스</a>
        </span>
      </div>

      <div className="hMenuArea">
        {userInfo.regUserName ? (
          <ul className="hMenuList hUserMenuList">
            <li style={{ cursor: 'pointer' }}>
              {userInfo?.login_type !== 'sso' && <div className="hMenuTxt notSSO">SSO 로그인이 아닙니다.</div>}
              <div className="hMenuImg">
                <img
                  src={IconUser}
                  alt="계정 아이콘"
                />
              </div>
              <div
                className="hMenuTxt"
                onClick={onUserNameClick}
              >
                {userInfo.user_nm}
                <span>님</span>
              </div>
            </li>
            <li>
              <button
                type="button"
                className="bHeight01 bFillType01"
                style={{ marginRight: '-16px' }}
                onClick={() => logoutEvent()}
              >
                <span>로그아웃</span>
              </button>
            </li>
            {isManagerApproved ? (
              <li
                className="goToMenu"
                onClick={() => navigate('/main/admin/user-list')}
              >
                <div className="hMenuImg">
                  <img
                    src={Setting}
                    alt="계정 아이콘"
                  />
                </div>
                <span className="settingMenu">사용자 관리</span>
              </li>
            ) : null}
          </ul>
        ) : (
          <></>
          // <ul className="hMenuList hUserMenuList">
          //   <li>
          //     <button
          //       type="button"
          //       className="bHeight01 bFillType01"
          //       onClick={() => handleSsoLogin()}
          //     >
          //       <span>SSO로그인</span>
          //     </button>
          //     &nbsp; &nbsp; &nbsp;
          //     <button
          //       type="button"
          //       className="bHeight01 bFillType01"
          //       onClick={() => {
          //         window.location.href = '/login';
          //       }}
          //     >
          //       <span>우회로그인</span>
          //     </button>
          //   </li>
          // </ul>
        )}
      </div>
    </header>
  );
};

export default MainHeaderTemplate;
